'use strict';

var $requestPromiseModule = require("request-promise");
var $cookiesModule = require('browser-cookies');

export default {
  $request: $requestPromiseModule,
  $cookies: $cookiesModule,
  //$api_url : "https://next-solutions.cz/commodity/api/admin/",
  //$api_service : "https://next-solutions.cz/commodity/api/service/",
  //$api_url : "https://next-solutions.cz/commodity/api-produkce/admin/",
  //$api_service : "https://next-solutions.cz/commodity/api-produkce/service/",
  // $api_url : "https://next-solutions.cz/commodity/api-beta/admin/",
  // $api_service : "https://next-solutions.cz/commodity/api-beta/service/",
  // $api_url : "https://www.next-solutions.cz/commodity/api-parovani/admin/",
  // $api_service : "https://next-solutions.cz/commodity/api-parovani/service/",
  $api_url : process.env.VUE_APP_API_URL, //"https://api.commodity.uwdemo.cz/admin/",
  $api_service : process.env.VUE_APP_API_SERVICE, //"https://api.commodity.uwdemo.cz/service/",
  get: function ($method) {
    var options = {
        uri: window.API.$api_url + $method + "?XDEBUG_SESSION_START=netbeans-xdebug",
        headers: {
            //'User-Agent': 'HN-WebClient'
        },
        json: true,
        cookies: [
          {
            name: "XDEBUG_SESSION",
            value: "netbeans-xdebug"
          }
        ]
    };
    if (this.$cookies.get("cc_com_token") !== null) {
        options.headers['Authorization'] = "Basic " + btoa("1:" + this.$cookies.get("cc_com_token"));
        options.headers['AuthToken'] = this.$cookies.get("cc_com_token");
    }
    return this.$request(options);
  },
  post: function($method, $data) {
    var options = {
        method: 'POST',
        uri: window.API.$api_url + $method + "?XDEBUG_SESSION_START=netbeans-xdebug&debug=true",
        body: $data,
        json: true,
        headers: {
            //'User-Agent': 'HN-WebClient'
        },
        cookies: [
          {
            name: "XDEBUG_SESSION",
            value: "netbeans-xdebug"
          }
        ]
    };
    if (this.$cookies.get("cc_com_token") !== null) {
        options.headers['Authorization'] = "Basic " + btoa("1:" + this.$cookies.get("cc_com_token"));
        options.headers['AuthToken'] = this.$cookies.get("cc_com_token");
    }
    return this.$request(options);
  },
  put: function($method, $data) {
    var options = {
        method: 'PUT',
        uri: window.API.$api_url + $method + "?XDEBUG_SESSION_START=netbeans-xdebug",
        body: $data,
        json: true,
        headers: {
            //'User-Agent': 'HN-WebClient'
        },
        cookies: [
          {
            name: "XDEBUG_SESSION",
            value: "netbeans-xdebug"
          }
        ]
    };
    if (this.$cookies.get("cc_com_token") !== null) {
        options.headers['Authorization'] = "Basic " + btoa("1:" + this.$cookies.get("cc_com_token"));
        options.headers['AuthToken'] = this.$cookies.get("cc_com_token");
    }
    return this.$request(options);
  },
  delete: function($method, $data) {
    var options = {
        method: 'DELETE',
        uri: window.API.$api_url + $method + "?XDEBUG_SESSION_START=netbeans-xdebug",
        json: true,
        headers: {
            //'User-Agent': 'HN-WebClient'
        },
        cookies: [
          {
            name: "XDEBUG_SESSION",
            value: "netbeans-xdebug"
          }
        ]
    };
    if (this.$cookies.get("cc_com_token") !== null) {
        options.headers['Authorization'] = "Basic " + btoa("1:" + this.$cookies.get("cc_com_token"));
        options.headers['AuthToken'] = this.$cookies.get("cc_com_token");
    }
    return this.$request(options);
  },
  upload: function($method, $formData) {

    return new Promise((resolve, reject) => {
      var $form = $formData;

      var xhr = new XMLHttpRequest();
      xhr.open('POST', window.API.$api_url + $method, true);
      //xhr.setRequestHeader('Content-Type', 'multipart/form-data');
      if (this.$cookies.get("cc_com_token") !== null) {
        xhr.setRequestHeader('Authorization', "Basic " + btoa("1:" + this.$cookies.get("cc_com_token")));
        xhr.setRequestHeader('AuthToken', this.$cookies.get("cc_com_token"));
      }

      xhr.upload.onprogress = function(e) {
        if (e.lengthComputable) {
          var percentComplete = (e.loaded / e.total) * 100;
          console.log(percentComplete + '% uploaded');
          window.UploadListener.show(percentComplete);
        }
      };
      xhr.onload = function() {
        if (this.status == 200) {
          window.UploadListener.hide();
          var resp = JSON.parse(this.response);
          resolve(resp);
        }
        else {
          reject();
        }
      };
      xhr.send($form);

    });
  },
  $setCookie: function($name, $value, $opts) {
    this.$cookies.set($name, $value, $opts);
  }
}



// WEBPACK FOOTER //
// ./src/assets/api.js